import config from '../config';
import { authFetch } from '../common/authentication';
import { type AuditTrailsGrouped } from '../common/domain/mappingAudit';

/**
 * Fetch the admin mapping audit trail
 *
 * @returns Promise resolving to mapping data array
 */
export const getMappingAuditTrail = async (): Promise< AuditTrailsGrouped > => {
  const response = await authFetch(
    `${config.endpoints.getMappingAuditTrail}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
  return response.json();
};
